import { Injector } from "@angular/core";
import { CoreCOMService } from "../com.service";
import { CoreLogService } from "../log.service";

export interface QRCodeStatus {
  "authorized": Boolean;
  "denied": Boolean;
  "restricted": Boolean;
  "prepared": Boolean;
  "scanning": Boolean;
  "previewing": Boolean;
  "showing": Boolean;
  "lightEnabled": Boolean;
  "canOpenSettings": Boolean;
  "canEnableLight": Boolean;
  "currentCamera": Number;
}

export interface IQRCodeScanner {
  prepare(): Promise<QRCodeStatus>;
  scan(): Promise<string>;
  // cancelScan(onCancel: (status: QRCodeStatus) => void);
  show(): Promise<QRCodeStatus>;
  // hide(onHideView: (status: QRCodeStatus) => void);
  enableLight(): Promise<QRCodeStatus>;
  disableLight(): Promise<QRCodeStatus>;
  // useFrontCamera(onFCameraSelect: (error: any, status: QRCodeStatus) => void);
  // useBackCamera(onBCameraSelect: (error: any, status: QRCodeStatus) => void);
  // useCamera(currentCamera: number, onSwitchCamera: (error: any, status: QRCodeStatus) => void);
  // pausePreview(onPreviewPause: (status: QRCodeStatus) => void);
  // resumePreview(onResumePreview: (status: QRCodeStatus) => void);
  // getStatus(onGetStatus: (status: QRCodeStatus) => void);
  destroy(): Promise<QRCodeStatus>;
}
// https://www.npmjs.com/package/cordova-plugin-flashlight
export class QRCodeScanner implements IQRCodeScanner {
  private qrScanner;

  constructor(private _coreLogService: CoreLogService) {
    this.qrScanner = window["QRScanner"];

    // interval in milliseconds at which to try decoding the QR code
    // this value can be adjusted on-the-fly (while a scan is active) to
    // balance scan speed vs. CPU/power usage
    window["QRScanner_SCAN_INTERVAL"] = 300;
  }

  public prepare(): Promise<QRCodeStatus> {
    const me = this;
    return new Promise<QRCodeStatus>((resolve, reject) => {
      me.qrScanner.prepare((err, status: QRCodeStatus) => {
        if (err) {
          me._coreLogService.error("QRCodeScanner Plugin prepare()", err.code, err._message);
          reject(err._message);
        } else {
          me.hideBackground();
          resolve(status);
        }
      });
    });
  }

  public scan(): Promise<string> {
    const me = this;
    return new Promise<string>((resolve, reject) => {
      me.qrScanner.scan((err, contents: string) => {
        if (err) {
          me._coreLogService.error("QRCodeScanner Plugin scan()", err.code, err._message);
          reject();
        } else {
          resolve(contents);
        }
      });
    });
  }

  public show(): Promise<QRCodeStatus> {
    const me = this;
    return new Promise<QRCodeStatus>((resolve, reject) => {
      me.qrScanner.show((status: QRCodeStatus) => {
        resolve(status);
      });
    });
  }

  public destroy(): Promise<QRCodeStatus> {
    const me = this;
    return new Promise<QRCodeStatus>((resolve, reject) => {
      me.qrScanner.destroy((status: QRCodeStatus) => {
        me.unhideBackground();
        resolve(status);
      });
    });
  }

  public enableLight(): Promise<QRCodeStatus> {
    const me = this;
    return new Promise<QRCodeStatus>((resolve, reject) => {
      me.qrScanner.enableLight((err, status: QRCodeStatus) => {
        if (err) {
          me._coreLogService.error("QRCodeScanner Plugin enableLight()", err.code, err._message);
          reject();
        } else {
          resolve(status);
        }
      });
    });
  }
  public disableLight(): Promise<QRCodeStatus> {
    const me = this;
    return new Promise<QRCodeStatus>((resolve, reject) => {
      me.qrScanner.disableLight((err, status: QRCodeStatus) => {
        if (err) {
          me._coreLogService.error("QRCodeScanner Plugin disableLight()", err.code, err._message);
          reject();
        } else {
          resolve(status);
        }
      });
    });
  }
  private unhideBackground() {
    document.getElementById("maincontent").classList.remove("hide-background");
    (document.getElementsByClassName("mat-drawer-container")[0] as HTMLElement).classList.remove("hide-background");
    (document.getElementsByClassName("mat-drawer-content")[0] as HTMLElement).classList.remove("hide-background");
    (document.getElementsByClassName("routeMainLayer")[0] as HTMLElement).classList.remove("hide-background");
    (document.getElementsByClassName("routeMainLayer")[0] as HTMLElement).classList.remove("gradient-background");
  }

  private hideBackground() {
    const mainContent = document.getElementById("maincontent");
    const routeMainLayer = document.getElementsByClassName("routeMainLayer")[0] as HTMLElement;
    if (!document.documentElement.style.getPropertyValue("--lpercent")) {
      if (mainContent && routeMainLayer) {
        if (mainContent.clientWidth < routeMainLayer.clientWidth) {
          const percent = +(((routeMainLayer.clientWidth - mainContent.clientWidth) * 100 / routeMainLayer.clientWidth).toFixed(0));
          document.documentElement.style.setProperty("--lpercent", `${percent}%`);
          document.documentElement.style.setProperty("--rpercent", `${100 - percent}%`);
        }
      }
    }
    mainContent.classList.add("hide-background");
    routeMainLayer.classList.add("hide-background");
    (document.getElementsByClassName("mat-drawer-container")[0] as HTMLElement).classList.add("hide-background");
    (document.getElementsByClassName("mat-drawer-content")[0] as HTMLElement).classList.add("hide-background");
    if (mainContent.clientWidth < routeMainLayer.clientWidth) {
      routeMainLayer.classList.add("gradient-background");
    }

  }
}
